import { ReactNode } from "react";

/**
 * Creates all custom cell renderers for Werkzoeken job sync table columns.
 * Returns a map of column keys to renderer functions.
 * The title cell is clickable and handles opening the vacancy drawer.
 */
export function createWerkzoekenCellRenderers(
  onTitleClick?: (row: unknown) => void
): Record<string, (value: unknown, row: unknown) => ReactNode> {
  const renderers: Record<string, (value: unknown, row: unknown) => ReactNode> = {};

  // ID renderer
  renderers.id = (value: unknown): ReactNode => {
    return (
      <span className="font-mono text-sm">
        {String(value ?? "")}
      </span>
    );
  };

  // Title renderer - clickable, opens vacancy drawer
  renderers.title = (value: unknown, row: unknown): ReactNode => {
    const title = String(value ?? "-");
    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation(); // Prevent row click
      if (onTitleClick) {
        onTitleClick(row);
      }
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (onTitleClick) {
          onTitleClick(row);
        }
      }
    };

    return (
      <span
        className="text-primary cursor-pointer hover:underline"
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        {title}
      </span>
    );
  };

  return renderers;
}
